"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translations = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var util_1 = require("@gooddata/util");
var en_US_json_1 = tslib_1.__importDefault(require("./bundles/en-US.json"));
var de_DE_json_1 = tslib_1.__importDefault(require("./bundles/de-DE.json"));
var es_ES_json_1 = tslib_1.__importDefault(require("./bundles/es-ES.json"));
var fr_FR_json_1 = tslib_1.__importDefault(require("./bundles/fr-FR.json"));
var ja_JP_json_1 = tslib_1.__importDefault(require("./bundles/ja-JP.json"));
var nl_NL_json_1 = tslib_1.__importDefault(require("./bundles/nl-NL.json"));
var pt_BR_json_1 = tslib_1.__importDefault(require("./bundles/pt-BR.json"));
var pt_PT_json_1 = tslib_1.__importDefault(require("./bundles/pt-PT.json"));
var zh_Hans_json_1 = tslib_1.__importDefault(require("./bundles/zh-Hans.json"));
var ru_RU_json_1 = tslib_1.__importDefault(require("./bundles/ru-RU.json"));
var sdkUiDashboardTranslations = {
    "en-US": util_1.translationUtils.removeMetadata(en_US_json_1.default),
    "de-DE": de_DE_json_1.default,
    "es-ES": es_ES_json_1.default,
    "fr-FR": fr_FR_json_1.default,
    "ja-JP": ja_JP_json_1.default,
    "nl-NL": nl_NL_json_1.default,
    "pt-BR": pt_BR_json_1.default,
    "pt-PT": pt_PT_json_1.default,
    "zh-Hans": zh_Hans_json_1.default,
    "ru-RU": ru_RU_json_1.default,
};
/**
 * @internal
 */
exports.translations = merge_1.default({}, 
// we also need the sdk-ui translations
sdk_ui_1.messagesMap, sdkUiDashboardTranslations);
//# sourceMappingURL=translations.js.map